var React = require('react');

function Like (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 20H8C6.9 20 6 19.1 6 18V8C6 7.45 6.22 6.95 6.58 6.59L13.17 0L14.23 1.05C14.5 1.32 14.67 1.7 14.67 2.11L14.64 2.43L13.69 7H20C21.1 7 22 7.9 22 9V11C22 11.26 21.95 11.5 21.86 11.73L18.84 18.78C18.54 19.5 17.83 20 17 20Z","fill":"white","key":0}),React.createElement("path",{"d":"M4 8H0V20H4V8Z","fill":"currentColor","key":1})]);
}

Like.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none"};

module.exports = Like;

Like.default = Like;
